(function () {
    window.WatchlistApp = window.WatchlistApp || {};

    const Summary = {
        calculateAndRenderSummary: function (data, holdings, interval) {
            if (!data || !holdings) return;
            let stockInfo = {};

            if (data.stockInfo && data.intervals) {
                stockInfo = data.stockInfo;
            } else if (window.WatchlistDataProcessor && typeof window.WatchlistDataProcessor.processWatchlistReport === 'function') {
                const processed = window.WatchlistDataProcessor.processWatchlistReport(data, interval);
                stockInfo = processed.stockInfo || {};
            } else {
                console.warn('[WatchlistApp] WatchlistDataProcessor not found, cannot calc summary');
                return;
            }

            let totalDayChange = 0;
            let totalPortfolioChange = 0;
            let currentPortfolioValue = 0;
            let totalQuantity = 0;

            Object.values(stockInfo).forEach(stock => {
                const ticker = stock.ticker;
                const holding = holdings[ticker];

                if (holding && holding.quantity && holding.price) {
                    const quantity = parseFloat(holding.quantity) || 0;
                    const totalCostBasis = parseFloat(holding.price) || 0;

                    if (quantity > 0 && totalCostBasis > 0) {
                        totalQuantity += quantity;
                        const price = parseFloat(stock.price) || 0;

                        const dayChangePerShare = parseFloat(stock.todaysChange) || 0;
                        totalDayChange += (dayChangePerShare * quantity);

                        const currentTotalValue = price * quantity;
                        
                        const gainLoss = currentTotalValue - totalCostBasis;
                        totalPortfolioChange += gainLoss;

                        currentPortfolioValue += currentTotalValue;
                    }
                }
            });

            const dayStartValue = currentPortfolioValue - totalDayChange;
            const totalDayChangePerc = dayStartValue !== 0 ? (totalDayChange / dayStartValue) * 100 : 0;
            const intervalStartValue = currentPortfolioValue - totalPortfolioChange;
            const totalPortfolioChangePerc = intervalStartValue !== 0 ? (totalPortfolioChange / intervalStartValue) * 100 : 0;
            const summary = document.querySelector('.watchlist-summary');
            if (summary) {
                if (totalQuantity === 0) {
                    summary.style.display = 'none';
                    return;
                }
                summary.style.display = 'flex';

                const vals = summary.querySelectorAll('.value');

                if (vals[0]) {
                    const absChange = Math.abs(totalDayChange);
                    const absPerc = Math.abs(totalDayChangePerc);

                    const signStr = totalDayChange >= 0 ? '+' : '-';

                    const txt = `${signStr}$${Math.round(absChange).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} (${signStr}${absPerc.toFixed(1)}%)`;
                    vals[0].textContent = txt;
                    vals[0].className = `value ${totalDayChange >= 0 ? 'positive' : 'negative'}`;
                }

                if (vals[1]) {
                    const signStr = totalPortfolioChange >= 0 ? '+' : '-';
                    const absChange = Math.abs(totalPortfolioChange);
                    const absPerc = Math.abs(totalPortfolioChangePerc);

                    const txt = `${signStr}$${Math.round(absChange).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} (${signStr}${absPerc.toFixed(1)}%)`;
                    vals[1].textContent = txt;
                    vals[1].className = `value ${totalPortfolioChange >= 0 ? 'positive' : 'negative'}`;
                }
            }
        }
    };

    window.WatchlistApp.Summary = Summary;
})();
